/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ShockProfileUpdate
 */
export interface ShockProfileUpdate {
    /**
     * 
     * @type {string}
     * @memberof ShockProfileUpdate
     */
    label?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ShockProfileUpdate
     */
    light?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ShockProfileUpdate
     */
    medium?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ShockProfileUpdate
     */
    severe?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ShockProfileUpdate
     */
    duration?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ShockProfileUpdate
     */
    xAxisScale?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ShockProfileUpdate
     */
    yAxisScale?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ShockProfileUpdate
     */
    zAxisScale?: number | null;
}

/**
 * Check if a given object implements the ShockProfileUpdate interface.
 */
export function instanceOfShockProfileUpdate(value: object): value is ShockProfileUpdate {
    return true;
}

export function ShockProfileUpdateFromJSON(json: any): ShockProfileUpdate {
    return ShockProfileUpdateFromJSONTyped(json, false);
}

export function ShockProfileUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShockProfileUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'label': json['label'] == null ? undefined : json['label'],
        'light': json['light'] == null ? undefined : json['light'],
        'medium': json['medium'] == null ? undefined : json['medium'],
        'severe': json['severe'] == null ? undefined : json['severe'],
        'duration': json['duration'] == null ? undefined : json['duration'],
        'xAxisScale': json['xAxisScale'] == null ? undefined : json['xAxisScale'],
        'yAxisScale': json['yAxisScale'] == null ? undefined : json['yAxisScale'],
        'zAxisScale': json['zAxisScale'] == null ? undefined : json['zAxisScale'],
    };
}

export function ShockProfileUpdateToJSON(json: any): ShockProfileUpdate {
    return ShockProfileUpdateToJSONTyped(json, false);
}

export function ShockProfileUpdateToJSONTyped(value?: ShockProfileUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'label': value['label'],
        'light': value['light'],
        'medium': value['medium'],
        'severe': value['severe'],
        'duration': value['duration'],
        'xAxisScale': value['xAxisScale'],
        'yAxisScale': value['yAxisScale'],
        'zAxisScale': value['zAxisScale'],
    };
}

